import { ICONS } from '@Const/common'
import Button from '@Components/Buttons/Button'
import AddDescriptionForm from '@Components/OverclaimView/DocumentForms/AddDescriptionForm'
import React, { RefObject, useState } from 'react'
import { UnifiedDocument } from '@Entities/document/document-to-upload'
import './index.scss'

interface UploadedDocumentProps {
    index: number
    docToUpload: UnifiedDocument
    onDescriptionChange?: (document: UnifiedDocument, description: string, index: number) => void
    descriptionHelpText?: string
    onRemove: (document: UnifiedDocument, index: number) => void
    browseFilePickerRef: RefObject<HTMLInputElement | null>
}

const UploadedDocument = (props: UploadedDocumentProps) => {
    const { index, docToUpload, browseFilePickerRef, descriptionHelpText, onDescriptionChange, onRemove } = props
    const isComplete = docToUpload.isComplete || false
    const shouldAllowDescription = !isComplete && !docToUpload.isExistingSelection && !!onDescriptionChange
    const [descriptionExpanded, setDescriptionExpanded] = useState(Boolean(docToUpload.description))

    return (
        <li>
            <div className="file-info">
                <img src={ICONS.documentIcon} alt="file-icon" />
                <div className="file-preview-name-container">
                    <b>{docToUpload.name}</b>
                    <div>{Math.floor(docToUpload.size / 1000)} KB</div>
                </div>

                {isComplete && <img className="file-uploaded-check-icon" src={ICONS.check} alt="check" />}

                {!isComplete && (
                    <Button
                        className="remove-file-button"
                        mainColor
                        type="tertiary"
                        onClick={() => {
                            if (browseFilePickerRef.current) {
                                browseFilePickerRef.current.value = ''
                            }
                            onRemove(docToUpload, index)
                        }}
                    >
                        Remove
                    </Button>
                )}
            </div>
            {shouldAllowDescription && (
                <div className="description-toggle-row">
                    <span>Add Note (Optional)</span>
                    <button
                        type="button"
                        className="description-toggle-button"
                        aria-label={`${descriptionExpanded ? 'Hide' : 'Show'} note field for ${docToUpload.name}`}
                        onClick={() => setDescriptionExpanded((currentValue) => !currentValue)}
                    >
                        <img src={descriptionExpanded ? ICONS.minus : ICONS.add} alt="" />
                    </button>
                </div>
            )}
            {shouldAllowDescription && descriptionExpanded && (
                <AddDescriptionForm
                    description={docToUpload.description ?? ''}
                    descriptionHelpText={descriptionHelpText}
                    showLabel={false}
                    setDescription={(newUpdatedDescription) => {
                        onDescriptionChange(docToUpload, newUpdatedDescription, index)
                    }}
                />
            )}
        </li>
    )
}
export default UploadedDocument
